import * as React from 'react';
import { useSelector } from 'react-redux';
import { FullStory } from '@cimpress-technology/react-reporting';
export const FullStoryRedux = ({ fsOptions, coamGroupId, blacklist, selector }) => {
    const sessionInformation = useSelector(selector) || {};
    return React.createElement(FullStory, { fsOptions: fsOptions, coamGroupId: coamGroupId, blacklist: blacklist, sessionInformation: sessionInformation });
};
//# sourceMappingURL=FullStory.js.map